import { ParticipantAccommodationReportTemplateData } from "./ParticipantAccommodationReportTemplateData";
import { ParticipantAccommodationReportImportTemplate } from "./ParticipantAccommodationReportImportTemplate";
import { cloneDeep } from "lodash";

export interface ParticipantAccommodation {
    firstName: string,
    lastName: string,
    eventname: string,
    dateFrom: string,
    dateTo: string,
    numberPersonInRoom: number,
    roomtypename: string,
    roomNumber: number,
    registration_status: string
};

export const getParticipantAccommodationReportTemplate = (
        reportData: ParticipantAccommodation[],
        accommodationName: string
    ) => {
    return ParticipantAccommodationReportImportTemplate(
        prepareData(reportData, accommodationName)
    );
};

const prepareData = (reportData: ParticipantAccommodation[], accommodationName: string) => {
    const templateData: ParticipantAccommodationReportTemplateData = {
        reportData: (cloneDeep(reportData)),
        accommodationName: accommodationName
    };
    return templateData;
};